// src/hooks/useInsuranceSession.ts

import { useCallback } from "react";

import {
  clearInsuranceStorage,
} from "../services/insurance-storage.service";

import type {
  ActivityLog,
  Authorization,
  Claim,
  EligibilityVerification,
  Enrollment,
  Policy,
  Provider,
  Report,
} from "../contexts/InsuranceContextType";

interface UseInsuranceSessionOptions {
  setClaims: React.Dispatch<
    React.SetStateAction<Claim[]>
  >;

  setPolicies: React.Dispatch<
    React.SetStateAction<Policy[]>
  >;

  setEnrollments: React.Dispatch<
    React.SetStateAction<Enrollment[]>
  >;

  setAuthorizations: React.Dispatch<
    React.SetStateAction<Authorization[]>
  >;

  setProviders: React.Dispatch<
    React.SetStateAction<Provider[]>
  >;

  setActivityLogs: React.Dispatch<
    React.SetStateAction<ActivityLog[]>
  >;

  setEligibilityVerifications: React.Dispatch<
    React.SetStateAction<
      EligibilityVerification[]
    >
  >;

  setReports: React.Dispatch<
    React.SetStateAction<Report[]>
  >;
}

interface UseInsuranceSessionReturn {
  logout: () => void;
}

export function useInsuranceSession({
  setClaims,
  setPolicies,
  setEnrollments,
  setAuthorizations,
  setProviders,
  setActivityLogs,
  setEligibilityVerifications,
  setReports,
}: UseInsuranceSessionOptions): UseInsuranceSessionReturn {
  const logout = useCallback(() => {
    clearInsuranceStorage();

    setClaims([]);
    setPolicies([]);
    setEnrollments([]);
    setAuthorizations([]);
    setProviders([]);
    setActivityLogs([]);
    setEligibilityVerifications([]);
    setReports([]);
  }, [
    setClaims,
    setPolicies,
    setEnrollments,
    setAuthorizations,
    setProviders,
    setActivityLogs,
    setEligibilityVerifications,
    setReports,
  ]);

  return {
    logout,
  };
}